<template>
  <table
    class="v-datatable v-table"
  >
    <slot/>
  </table>
</template>

<script>
export default {
  name: 'Table',
  props: {
    bordered: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: true
    },
    hoverable: {
      type: Boolean,
      default: true
    }
  }
}
</script>
